import { Navigate } from "react-router";

import type { AreaRoutes } from "@/app/routes/hr/areaRoutes";
import { RequireCapability } from "@/app/session/RequireCapability";

/* Performance: review cycles and calibration (HR), writing reviews, results, goals and key
   results, one-to-ones and feedback. Every page answers 404 while the area is switched off;
   HR's section also explains itself to people without performance.manage. Notifications link
   to growth/reviews and growth/feedback. */
export const performanceRoutes: AreaRoutes = {
  people: [
    {
      element: <RequireCapability feature="performance" />,
      children: [
        {
          path: "performance",
          lazy: async () => ({
            Component: (await import("@/features/performance/routes/PerformanceHubLayout")).default,
          }),
          children: [
            { index: true, element: <Navigate to="cycles" replace /> },
            {
              path: "cycles",
              lazy: async () => ({
                Component: (await import("@/features/performance/routes/CyclesPage")).default,
              }),
            },
            {
              path: "cycles/:cycleId",
              lazy: async () => ({
                Component: (await import("@/features/performance/routes/CycleDetailPage")).default,
              }),
            },
            {
              path: "templates",
              lazy: async () => ({
                Component: (await import("@/features/performance/routes/TemplatesPage")).default,
              }),
            },
          ],
        },
      ],
    },
  ],
  employee: [],
  me: [
    {
      element: <RequireCapability feature="performance" />,
      children: [
        {
          path: "growth",
          lazy: async () => ({
            Component: (await import("@/features/performance/routes/GrowthLayout")).default,
          }),
          children: [
            { index: true, element: <Navigate to="reviews" replace /> },
            {
              path: "reviews",
              lazy: async () => ({
                Component: (await import("@/features/performance/routes/MyReviewsPage")).default,
              }),
            },
            {
              path: "reviews/:reviewId",
              lazy: async () => ({
                Component: (await import("@/features/performance/routes/ReviewFormPage")).default,
              }),
            },
            {
              path: "results/:participantId",
              lazy: async () => ({
                Component: (await import("@/features/performance/routes/ResultsPage")).default,
              }),
            },
            {
              path: "goals",
              lazy: async () => ({
                Component: (await import("@/features/performance/routes/GoalsPage")).default,
              }),
            },
            {
              path: "goals/:goalId",
              lazy: async () => ({
                Component: (await import("@/features/performance/routes/GoalDetailPage")).default,
              }),
            },
            {
              path: "one-on-ones",
              lazy: async () => ({
                Component: (await import("@/features/performance/routes/OneOnOnesPage")).default,
              }),
            },
            {
              path: "one-on-ones/:meetingId",
              lazy: async () => ({
                Component: (await import("@/features/performance/routes/MeetingPage")).default,
              }),
            },
            {
              path: "feedback",
              lazy: async () => ({
                Component: (await import("@/features/performance/routes/FeedbackPage")).default,
              }),
            },
            {
              path: "team",
              lazy: async () => ({
                Component: (await import("@/features/performance/routes/MyTeamPage")).default,
              }),
            },
          ],
        },
      ],
    },
  ],
  top: [],
};
